var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.alert
    ? _c(
        "b-alert",
        { attrs: { show: !!_vm.alert.message, variant: "danger" } },
        [
          _vm._v("\n    " + _vm._s(_vm.alert.message) + " \n    "),
          _vm.alert.errors
            ? _vm._l(_vm.alert.errors, function(error, index) {
                return _c("span", { key: index }, [
                  _vm._v(" " + _vm._s(error[0]))
                ])
              })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }